import { locationTrackersOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { LocationTrackerDto, LocationTrackerListDto, PagedResultDto, PartialListDto } from "../api/types";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("location-trackers"),
  endpoint: "location-trackers",
  operations: locationTrackersOps,
  roleView: [ROLE.LOC_TRACK_VIEW, ROLE.LOC_TRACK_ADMIN],
  roleAdmin: [ROLE.LOC_TRACK_ADMIN],
  baseRoute: "location-trackers",
  singularName: (t) => t("Location tracker"),
  name: (t) => t("Location trackers"),
  sendCulture: true,
  infiniteNormalizer: (value: PartialListDto<LocationTrackerListDto>) => {
    const results = value.results
      .filter((v) => v !== undefined)
      .map((v) => ({
        name: `${v.macAddress} | ${v?.type?.name}`,
        id: v.id,
        type: v.type,
      }));
    return {
      ...value,
      results,
    };
  },
  normalizer: (value: PagedResultDto<LocationTrackerDto>) => {
    return {
      ...value,
      results: value.results.map((v: any) => ({
        ...v,
        name: `${v.macAddress} | ${v?.type?.name}`,
      })),
    };
  },
  syncCustomerFilter: true,
});

export default conf;
